import styled from 'styled-components';
import { DebounceInput } from '../DebounceInput';

export const StyledInput = styled(DebounceInput)({
  lineHeight: '20px',
  resize: 'none',
  padding: '12px',
  overflow: 'hidden',
  minHeight: '96px',
});

export const Wrapper = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '8px',
});

export const Counter = styled.div({
  position: 'absolute',
  right: 0,
  top: '-24px',
  height: '16px',
  fontSize: '12px',
});
